import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Regions } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/regions`,
    response: [] as Regions.Get.Region[],
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
